export default {
  "content": "<g clip-path=\"url(#illustrationtop-clip0)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0h494a5 5 0 015 5v16H0V5a5 5 0 015-5z\" fill=\"#E4E4E9\"/><path d=\"M12.5 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM25.5 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM38.5 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9z\" fill=\"#949499\"/><path d=\"M504 21H0v1h504v-1z\" fill=\"#C4C4CA\"/></g><defs><clipPath id=\"illustrationtop-clip0\"><path fill=\"#fff\" d=\"M0 0h504v21.5H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "504",
    "height": "22",
    "viewBox": "0 0 504 22",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};